import React from "react";

export default function FixTableContainer(prop) {
  return (
    <div className="bootstrap-table bootstrap4">
      <div className="fixed-table-container">
        <div className="fixed-table-body">{prop.children}</div>
      </div>
    </div>
  );
}
